export const DEFAULT_ACCENT = '#d97757';

export const ACCENT_PRESETS = [
  { name: 'Terracotta', value: DEFAULT_ACCENT },
  { name: 'Sage', value: '#88a878' },
  { name: 'Ocean', value: '#5e91c9' },
  { name: 'Violet', value: '#9b7bd4' },
  { name: 'Rose', value: '#c86e8a' },
  { name: 'Gold', value: '#c99a4a' },
] as const;

export function applyAccent(value: string): void {
  const accent = /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : DEFAULT_ACCENT;
  window.document.documentElement.style.setProperty('--accent', accent);
}
